import { Controller } from "@hotwired/stimulus"

// „Samtals" keeps up with the fields. The header sits above a form the ref
// types their way down, and a figure that only caught up on „Vista" was a
// figure they had to take on trust while they worked.
//
// Added up here rather than asked for: it is the same twelve numbers that are
// already on the screen, so a request per keystroke would buy nothing and cost
// a blink. The server's figure is the one rendered - this never recalculates on
// connect, so a row is shown what it was saved as until something is typed.
export default class extends Controller {
  static targets = [ "amount", "output" ]
  static values = { carried: Number }

  // The amounts are the currency-masked fields and nothing else. „Tímafjöldi"
  // is a quantity, not krónur - it carries no target, and twelve hours must
  // never arrive here as twelve krónur.
  recalculate() {
    const total = this.amountTargets.reduce((sum, field) => sum + this.amount(field), this.carriedValue)

    this.outputTarget.textContent = this.delimited(total)
  }

  // The mask is asked, not the box: what is in the box is „83.550", and the
  // separator is the same character the sum would then be missing.
  amount(field) {
    const imask = this.application.getControllerForElementAndIdentifier(field, "imask")
    const raw = imask && imask.mask ? imask.mask.unmaskedValue : field.value

    return Number(raw) || 0
  }

  // The thousands separator the rest of the screen uses, rather than whatever
  // the browser's locale data has to say about Icelandic.
  delimited(amount) {
    return String(amount).replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }
}
